import { PropsWithChildren } from "react";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import { FeatureExposed } from "@/utils/feature-exposed";

import { OnboardingContainerProps } from "../../../components";

export const JiraOnboardingContainer = ({
    header,
    subheader,
    hideSubHeader, // go with experiment jsw_transparent_software_jtbd
    children,
    fadeOutContent = false,
    size = "lg"
}: OnboardingContainerProps & PropsWithChildren) => (
    <FeatureExposed
        experimentKey="jfind-1565-sign-up-flow-overlay"
        group="Test"
    >
        <JiraOverlayTemplate
            header={header}
            subheader={hideSubHeader ? " " : subheader}
            size={size}
            fadeOutContent={fadeOutContent}
        >
            {children}
        </JiraOverlayTemplate>
    </FeatureExposed>
);
